import TextLocal from '@/src/textLocal/containers/TextLocal';

import AuthenticationLayout from '../../authenticationLayout/componetns/AuthantificationLayout';
import AuthenticationTitles from '../../authenticationTiltes/components/AuthenticationTitles';
import css from '../styles/singIn.module.css';
import SignInForm from './SignInForm';

interface SignInProps {
  handleSubmit: (...args: any) => void;
  isLoading: boolean;
}

const SignIn = ({handleSubmit, isLoading}: SignInProps) => {
  return (
    <AuthenticationLayout withSignUpButton={true}>
      <div className={css.mainWrapper}>
        <AuthenticationTitles
          mainTitle={<TextLocal id={'sing-in.main-title'} />}
          subTitle={<TextLocal id={'sing-in.sub-title'} />}
        />
        <SignInForm handleSubmit={handleSubmit} isLoading={isLoading} />
      </div>
    </AuthenticationLayout>
  );
};

export default SignIn;

SignIn.defaultProps = {
  handleSubmit: () => {},
  isLoading: false,
};
